import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ISimpleChannelResponseV2,
  IUserResponseV2,
} from '@/src/v2/service/v2/graphql/generated/gql-api.generated';

type UserSlice = {
  user: IUserResponseV2 | null;
  channel: ISimpleChannelResponseV2 | null;
  isLogging: boolean;
};

const initialState: UserSlice = {
  user: null,
  channel: null,
  isLogging: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state: UserSlice,
      action: PayloadAction<IUserResponseV2 | null>
    ) => {
      state.user = action.payload;
    },
    setChannel: (
      state: UserSlice,
      action: PayloadAction<ISimpleChannelResponseV2 | null>
    ) => {
      state.channel = action.payload;
    },
    setIsLogging: (state: UserSlice, action: PayloadAction<boolean>) => {
      state.isLogging = action.payload;
    },
  },
});

export const { setUser, setChannel, setIsLogging } = userSlice.actions;

export default userSlice.reducer;
